import Vue from "vue";
import App from "./App.vue";

// import custom components from flexi-vue framework
import "@schnapsterdog/flexi-vue";

//import tui-image CSS
import "tui-image-editor/dist/tui-image-editor.css";

// import router
import router from "./router";

// import vueX
import store from "./store";

// If we need to use some common stuff through the app, feel free to create files into mixins folder
import "./mixins";

// Vee Validate
import "./validators";

// Modernistic/Minimalist Epic Spinners. Description/usage given into the file
import "./animation/spinners";

// LowerCase, V-tooltip and custom directives. If u want to create new global directive, give it a shot into the file
import "./directives";

// Great Animation on Scroll Library. For usage, see into App.vue
import AOS from "aos";
import "aos/dist/aos.css";

//typing animation
import "./animation/typing";

//page transition
import "./animation/page-transition";

//CheckView

import checkView from "vue-check-view";
Vue.use(checkView);

Vue.config.productionTip = false;
// ignore ion icons components
Vue.config.ignoredElements = [/^ion-/];

new Vue({
  router,
  store,
  created() {
    AOS.init({});
  },
  render: h => h(App)
}).$mount("#app");
